import { SET_LAST_SELECTED_ACTION_POPOVER_ID } from 'email-management-lib/refactor/actions/actionTypes';
export default function lastSelectedActionPopoverId(state = '', action) {
  switch (action.type) {
    case SET_LAST_SELECTED_ACTION_POPOVER_ID:
      return action.payload;
    default:
      return state;
  }
}